<!-- 高德地图POI搜索组件 -->
<template>
<div class="poi_search_box" v-click-outside="onClickOutside">
  <input class="search_input" type="text" maxlength="30" placeholder="请输入关键字" v-model.trim="keyword"
    @focus.prevent="onFocus" @keydown="onKeydown" @input="onInput" />
  <el-button class="search_btn" @click.stop="handleSearch">搜索</el-button>
  <div v-show="visible && keyword !== ''" class="poi_ul">
    <div v-if="!pois || pois.length === 0" class="no_data">暂无搜索结果</div>
    <div v-for="(w, j) in pois" :key="j" :class="{ 'poi_item': true, 'hover': hoverIndex == j }"
      @click.stop="onSelectPoi(w)">
      <span v-html="w.htmlStr"></span>
      <span class="poi_addr">{{ w.district }}</span>
    </div>
  </div>
</div>
</template>

<script>
import DebounceThrot from '@/utils/debounceThrot'

export default {
  directives: {},
  data() {
    return {
      keyword: '',
      visible: false,
      hoverIndex: -1
    }
  },
  computed: {
    pois() {
      return this.$store.state.bmap.searchedPois.map(poi => {
        const splited = poi.name.split(this.keyword)
        poi.htmlStr = splited.join(`<span class='word_match'>${this.keyword}</span>`)
        return poi
      })
    }
  },
  watch: {
    visible(v) {
      if (!v) {
        this.hoverIndex = -1
        this.$store.commit('setSearchedPois', [])
      }
    }
  },
  beforeDestroy() {
    // this.$root.$off('operateResetSetCity')
  },
  mounted() {
    this.$root.$on('operateResetSetCity', () => {
      this.keyword = ''
    })
  },
  methods: {
    onClickOutside() {
      this.visible = false
    },
    // 键盘按键按下事件
    onKeydown(e) {
      // 事件防抖
      DebounceThrot.debounceSimple(300, () => {
        /**
         * 判断字母按键推荐用e.code（KeyA/KeyB...）
         * 字母键的e.key为'a/A/b/B...'
         * 判断其他字符按键推荐用e.key
         */
        switch (e.key) {
          case 'Enter': {
            if (!this.visible || this.hoverIndex === -1) {
              this.handleSearch()
            } else {
              this.onSelectPoi(this.pois[this.hoverIndex])
            }
            break
          }
          // 按下向上箭头
          case 'ArrowUp': {
            if (this.visible) {
              let hover = this.hoverIndex - 1
              if (hover < 0) {
                hover = this.pois.length - 1
              }
              this.hoverIndex = hover
            }
            break
          }
          // 按下向下箭头
          case 'ArrowDown': {
            if (this.visible) {
              let hover = this.hoverIndex + 1
              if (hover >= this.pois.length) {
                hover = 0
              }
              this.hoverIndex = hover
            }
            break
          }
          default:
            break
        }
      })
    },
    onInput(e) {
      this.visible = false
      DebounceThrot.debounceSimple(500, () => {
        this.handleSearch()
      })
    },
    // 输入框聚焦，且输入框有值时触发一次POI搜索
    onFocus(e) {
      e.stopImmediatePropagation()
      e.preventDefault()
      if (!this.visible && this.keyword !== '') {
        this.handleSearch()
      }
    },
    async handleSearch() {
      if (!this.keyword) return
      let cityName
      let seniorCityGuid = this.$store.state.bmap.mapSearchOptionsSenior.city
      if (!seniorCityGuid) {
        cityName = this.$store.state.bmap.mapZoomData.city?.districtValue
      } else {
        cityName = this.$store.state.bmap.mapCityList.filter(e => e.guid == seniorCityGuid)[0].districtValue
      }

      if (cityName && cityName.endsWith('辖区')) {
        cityName = cityName.substring(0, cityName.length - 2)
      }

      const para = {
        keyword: this.keyword,
        option: {
          city: cityName,
          citylimit: true
        }
      }
      await this.$store.dispatch('poiSearch', para)

      this.visible = true
    },
    onSelectPoi(p) {
      this.keyword = p.name
      if (p && p.location && p.location instanceof AMap.LngLat) {
        this.$store.commit('setFocusPoint', { location: p.location })
      }
      this.visible = false
      this.$emit('selectPoi', p)
    }
  }
}
</script>

<style lang="scss" scoped>
.poi_search_box {
  position: relative;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .search_input {
    width: 240px;
    height: 100%;
    color: #282729;
    padding: 0 20px;
    border: none;
    border-radius: 4px 0 0 4px;
    &::placeholder {
      color: #AFAFAF;
    }
  }
  .search_btn {
    width: 80px;
    height: 100%;
    color: #282729;
    font-size: 14px;
    background: linear-gradient(315deg, #FAEA61 0%, #FFB81F 100%);
    border: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    vertical-align: bottom;
  }
  .poi_ul {
    position: absolute;
    top: 48px;
    left: 0;
    right: 0;
    width: 100%;
    max-height: 400px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 8px 0px rgba(40, 39, 41, 0.3);
    overflow: auto;
    padding: 10px 15px;
    z-index: 2;
    .no_data {
      font-size: 12px;
      color: #999;
      padding: 10px 0;
      text-align: center;
    }
    ::v-deep .word_match {
      color: #FF3973;
    }
    .poi_item {
      cursor: pointer;
      color: #282729;
      font-size: 12px;
      line-height: 20px;
      margin: 0;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      &:hover, &.hover {
        background-color: #f5f5f5;
      }
      .poi_addr {
        color: #999999;
        margin-left: 10px;
      }
    }
  }
}
</style>
